// import React, { useEffect } from "react";
// import { Row, Col } from "react-bootstrap";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import "sweetalert2/src/sweetalert2.scss";
// import { BsCoin } from "react-icons/bs";
// import { ImTarget } from "react-icons/im";
// import { FaChartLine } from "react-icons/fa";
// import aboutHero from "../../assets/img/logos.jpg";
// import inspiration from "../../assets/img/wood.jpg";
// import infrastructure from "../../assets/img/logos.jpg";
// import incrediants from "../../assets/img/brass.jpg";
// import cultivation from "../../assets/img/iron.jpg";
// import AboutCard from "./AboutCard";

// export default function About() {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const fullViewInspiration = () => {
//     Swal.fire({
//       title: "INSPIRATION",
//       text: "In 2020 while most of us had to face the pandemic, we were in need of natural healthy products for our kids to improve the immunity. But we had access to only few and others were not available. So we started to cultivate on our own to satisfy our own needs...",
//     });
//   };

//   const fullViewInfrastructure = () => {
//     Swal.fire({
//       title: "INFRASTRUCTURE",
//       text: "Our farm is located about 120 kms from Chennai that expands the landscape of about 2.5 Acers own Land. (15 Acers Leased Out) Hence it makes us feasible to cultivate all our ingredients in our farm that is free from Pesticides",
//     });
//   };

//   const fullViewIngrediants = () => {
//     Swal.fire({
//       title: "INGREDIANTS AND FREE OF HARMFUL CHEMICALS",
//       text: "We follow the Sri Mangalambika Stores quality Ingredients Standard in all our proprietary formulations...",
//     });
//   };

//   const fullViewCultivation = () => {
//     Swal.fire({
//       title: "CULTIVATION",
//       text: "We use the highest possible concentration of organic and wild crafted ingredients in every treatment...",
//     });
//   };

//   return (
//     <>
//       <section className="py-5" style={{ backgroundColor: "#e0e0e0" }}>
//         <div className="container">
//           <div className="row align-items-center py-5">
//             <div className="col-md-8 text-white">
//               <h1 className="text-success">About Us</h1>
//               <p className="text-dark" style={{ textAlign: "justify" }}>
//                 In 1949, Mr. Kalimuthu Pillai had an iron shop inside the
//                 Kumbeshwarar temple.
//                 <br />
//                 <strong>
//                   2<sup>nd</sup> Generation:
//                 </strong>{" "}
//                 His son, K. Thaiyagarajan, started in the 1980s making products
//                 by hand behind his house. He carried heavy items to sell in
//                 Kumbakonam, Mannargudi, and Mayiladuthurai. After years of hard
//                 work, he started a small-scale industry near Kumbeswarar Kovil
//                 in 1983 and later opened a retail and wholesale shop named Sri
//                 Mangalambika Stores in 2002, selling homeware products like dosa
//                 tawas, iron kadais, and iron stoves.
//                 <br />
//                 <strong>
//                   3<sup>rd</sup> Generation:
//                 </strong>{" "}
//                 After his death, his sons T. Mohan and T. Ravichandran took over
//                 the business. With the support of T. Mohan (B.A. B.L.) and
//                 family, T. Ravichandran expanded the shop from a shed to a
//                 building with dedicated manufacturing and sales areas. He also
//                 constructed a new building across the street and managed that
//                 shop for 10 years.
//                 <br />
//                 <strong>
//                   4<sup>th</sup> Generation:
//                 </strong>{" "}
//                 Now, R. Devanandh (M.Com.) and M. Keerthivasan (MBA) manage the
//                 family business. They’ve brought the business online, offering
//                 ready-to-use (pre-seasoned) quality products at the best prices
//                 for customer comfort and convenience.
//               </p>
//             </div>
//             <div className="col-md-4">
//               <img src={aboutHero} alt="About Hero" className="img-fluid" height="300px" width="400px" style={{borderRadius:"20px"}} />
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="container py-3">
//         <div className="row text-center pt-5 pb-3">
//           <div className="col-lg-12 m-auto">
//             <h1 className="h1">Our Story</h1>
//             <p>
//               Pure & Authentic – No harmful chemicals or coatings. Just nature’s
//               best. Handcrafted by Artisans – Each piece carries a story of
//               skill and heritage. Eco-Friendly & Sustainable – Good for you,
//               good for the planet. Enhances Taste & Health – Retains nutrients
//               and natural flavors. At Sri Mangalambika Stores, we are not just
//               selling cookware—we are reviving a healthier, tastier, and more
//               sustainable way of life. Join us in bringing tradition back to
//               your kitchen!
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="container py-1">
//         <Row>
//           <Col xs={12} sm={6} md={6} lg={6} xl={3}>
//             <AboutCard
//               image={inspiration}
//               cardStyle="aboutCard"
//               title="Inspiration"
//               contents="In 2020 while most of us had to face the pandemic, we were in need of natural healthy products..."
//               readMore={fullViewInspiration}
//             />
//           </Col>
//           <Col xs={12} sm={6} md={6} lg={6} xl={3}>
//             <AboutCard
//               image={infrastructure}
//               cardStyle="aboutCard"
//               title="Infrastructure"
//               contents="Our farm is located about 120 kms from Chennai that expands the landscape..."
//               readMore={fullViewInfrastructure}
//             />
//           </Col>
//           <Col xs={12} sm={6} md={6} lg={6} xl={3}>
//             <AboutCard
//               image={incrediants}
//               cardStyle="aboutCard"
//               title="Ingredients Standard"
//               contents="We follow the Sri Mangalambika Stores quality Ingredients Standard..."
//               readMore={fullViewIngrediants}
//             />
//           </Col>
//           <Col xs={12} sm={6} md={6} lg={6} xl={3}>
//             <AboutCard
//               image={cultivation}
//               cardStyle="aboutCard"
//               title="Cultivation"
//               contents="We use the highest possible concentration of organic and wild crafted..."
//               readMore={fullViewCultivation}
//             />
//           </Col>
//         </Row>

//         <div className="row d-flex justify-content-center my-3">
//           <div className="col-md-4 col-lg-4">
//             <div className="px-5 services-icon-wap">
//               <div className="h1 aboutIcon text-center">
//                 <ImTarget />
//               </div>
//               <h2 className="h5 mt-4 text-center">Mission</h2>
//               <p
//                 className="text-justify"
//                 style={{ fontSize: "15px", fontWeight: "400" }}
//               >
//                 Plants in Sri Mangalambika Stores are grown in their ideal
//                 habitats, allowing them to thrive and reach peak potential.
//               </p>
//             </div>
//           </div>

//           <div className="col-md-4 col-lg-4">
//             <div className="px-5 services-icon-wap">
//               <div className="h1 aboutIcon text-center">
//                 <FaChartLine />
//               </div>
//               <h2 className="h5 mt-4 text-center">Vision</h2>
//               <p
//                 className="text-justify"
//                 style={{ fontSize: "15px", fontWeight: "400" }}
//               >
//                 We started with skin/hair care products and fertilizers. By
//                 2023, we plan to expand into food products, vegetables, fruits,
//                 pulses, etc.
//               </p>
//             </div>
//           </div>

//           <div className="col-md-4 col-lg-4">
//             <div className="px-5 services-icon-wap">
//               <div className="h1 aboutIcon text-center">
//                 <BsCoin />
//               </div>
//               <h2 className="h5 mt-4 text-center">Values</h2>
//               <p
//                 className="text-justify"
//                 style={{ fontSize: "15px", fontWeight: "400" }}
//               >
//                 We sell the highest quality natural and organic products. We
//                 delight our customers with the right product, quantity, quality,
//                 and timing.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }
import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { BsCoin } from "react-icons/bs";
import { ImTarget } from "react-icons/im";
import { FaChartLine } from "react-icons/fa";
import aboutHero from "../../assets/img/logos.jpg";
import inspiration from "../../assets/img/ironn.jpg";
import infrastructure from "../../assets/img/brass.jpg";
import incrediants from "../../assets/img/wooden.jpg";
import cultivation from "../../assets/img/soap.jpg";
import AboutCard from "./AboutCard";
import apiClient from "../../utils/api";
import { useNavigate } from "react-router-dom";
// import "./about.css"; // Make sure you create and import this CSS

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sectionTitle = {
    fontSize: "2.2rem",
    fontWeight: "600",
    color: "#28a745",
    textAlign: "center",
    marginBottom: "1rem",
  };

  const textJustify = {
    textAlign: "justify",
  };

  const aboutImageStyle = {
    borderRadius: "20px",
    width: "100%",
    height: "auto",
    objectFit: "cover",
  };

  const aboutCardStyle = {
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding: "20px",
    height: "100%",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    transition: "transform 0.3s ease",
  };

  const aboutIcon = {
    fontSize: "40px",
    color: "#28a745",
    textAlign: "center",
  };

  const productCards = [
    { path: "/herbalProduct", img: inspiration, title: "Iron and cast iron" },
    { path: "/gardenProduct", img: infrastructure, title: "Brass and bronze" },
    { path: "/yogaProduct", img: incrediants, title: "Wooden and toys" },
    { path: "/spices", img: cultivation, title: "Soap stone" },
  ];
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <>
      <section className="py-5" style={{ backgroundColor: "#e0e0e0" }}>
        <div className="container">
          <div className="row align-items-center py-5">
            <div className="col-md-8">
              <h1 className="text-success">About Us</h1>
              <p
                className="text-dark"
                style={{ textAlign: "justify", fontFamily: "Poppins" }}
              >
                In 1949, Mr. Kalimuthu Pillai had an iron shop inside the
                Kumbeshwarar temple. <br />{" "}
                <strong>
                  2<sup>nd</sup> Generation:{" "}
                </strong>{" "}
                His son, K. Thaiyagarajan, started in the 1980s making products
                by hand behind his house. He carried heavy items to sell in
                Kumbakonam, Mannargudi, and Mayiladuthurai. After years of hard
                work, he started a small-scale industry near Kumbeswarar Kovil
                in 1983 and later opened a retail and wholesale shop named sri
                mangalambika storess in 2002, selling homeware products like
                dosa tawas, iron kadais, and iron stoves. <br />{" "}
                <strong>
                  3<sup>rd</sup> Generation:{" "}
                </strong>{" "}
                After his death, his sons T. Mohan and T. Ravichandran took over
                the business. With the support of T. Mohan (B.A. B.L.) and
                family, T. Ravichandran expanded the shop from a shed to a
                building with dedicated manufacturing and sales areas. He also
                constructed a new building across the street and managed that
                shop for 10 years. <br />{" "}
                <strong>
                  4<sup>th</sup> Generation:{" "}
                </strong>{" "}
                Now, R. Devanandh (M.Com.) and M. Keerthivasan (MBA) manage the
                family business. They’ve brought the business online, offering
                ready-to-use (pre-seasoned) quality products at the best prices
                for customer comfort and convenience.{" "}
              </p>
            </div>
            <div className="col-md-4">
              <img src={aboutHero} alt="About" style={aboutImageStyle} />
            </div>
          </div>
        </div>
      </section>

      <section className="container py-5">
        <div className="text-center mb-4">
          <h1 style={sectionTitle}>Our Story</h1>
          <p style={{ fontFamily: "Poppins" }}>
            Pure & Authentic – No harmful chemicals or coatings. Just nature’s
            best. Handcrafted by Artisans – Each piece carries a story of skill
            and heritage. Eco-Friendly & Sustainable – Good for you, good for
            the planet. Enhances Taste & Health – Retains nutrients and natural
            flavors. At Sri Mangalambika Stores, we are not just selling
            cookware—we are reviving a healthier, tastier, and more sustainable
            way of life. Join us in bringing tradition back to your kitchen!{" "}
          </p>
        </div>

        {/* <Row className="g-4">
          <Col xs={12} sm={6} md={6} lg={3}>
            <div style={{ ...aboutCardStyle, cursor: "pointer" }}>
              <AboutCard image={inspiration} />
            </div>
          </Col>
          <Col xs={12} sm={6} md={6} lg={3}>
            <div style={{ ...aboutCardStyle, cursor: "pointer" }}>
              <AboutCard image={infrastructure} />
            </div>
          </Col>
          <Col xs={12} sm={6} md={6} lg={3}>
            <div style={{ ...aboutCardStyle, cursor: "pointer" }}>
              <AboutCard image={incrediants} />
            </div>
          </Col>
          <Col xs={12} sm={6} md={6} lg={3}>
            <div style={{ ...aboutCardStyle, cursor: "pointer" }}>
              <AboutCard image={cultivation} />
            </div>
          </Col>
        </Row> */}

        <Row className="g-4">
          {productCards.map((card, index) => (
            <Col xs={12} sm={6} md={6} lg={3} key={index}>
              <div
                style={{ ...aboutCardStyle, cursor: "pointer" }}
                onClick={() => handleCardClick(card.path)}
              >
                <AboutCard image={card.img} />
                <h5 className="text-center mt-2">{card.title}</h5>
              </div>
            </Col>
          ))}
        </Row>

        <Row className="mt-5 text-center g-4">
          <Col md={4}>
            <div className="px-3">
              <div style={aboutIcon}>
                <ImTarget />
              </div>
              <h5 className="mt-3">Mission</h5>
              <p style={{ ...textJustify, fontFamily: "Poppins" }}>
                To craft and offer high-quality, handmade iron and cast iron
                products. To ensure all our products are free from harmful
                coatings or chemicals. To grow our presence across regions while
                staying committed to purity and customer trust...
              </p>
            </div>
          </Col>
          <Col md={4}>
            <div className="px-3">
              <div style={aboutIcon}>
                <FaChartLine />
              </div>
              <h5 className="mt-3">Vision</h5>
              <p style={{ ...textJustify, fontFamily: "Poppins" }}>
                To become a trusted household name for traditional iron, cast
                iron, and bronze cookware, offering every family a healthier and
                chemical-free cooking experience—rooted in quality, tradition,
                and care...
              </p>
            </div>
          </Col>
          <Col md={4}>
            <div className="px-3">
              <div style={aboutIcon}>
                <BsCoin />
              </div>
              <h5 className="mt-3">Values</h5>
              <p style={{ ...textJustify, fontFamily: "Poppins" }}>
                Quality organic products with the right quantity, quality, and
                timing for all customers...
              </p>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
}
